import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import * as R from 'ramda';

import { Container } from 'components/shared/container/Container.styled';
import { SectionFlattenProps } from '../section/Section.props';
import { translate } from 'shared/utils/translate';
import { ParagraphRegular } from 'components/shared/typography';
import * as Styled from './MapNextToText.styled';

const MapNextToText = ({
  components = [],
  theme,
  intl,
}: WrappedComponentProps & SectionFlattenProps) => {
  const component = components[0];

  if (!component) return null;

  const { body, imageUrl } = component;
  const url = imageUrl || '';
  const color = theme?.color || '';
  const backgroundColor = theme?.backgroundColor || '';

  return (
    <Container size="lg">
      <Styled.Wrapper>
        {url && <Styled.Image url={url} data-map-image-container />}
        <Styled.Description
          backgroundColor={backgroundColor}
          withPadding={!!backgroundColor}
          data-map-text-container
        >
          {body && (
            <ParagraphRegular color={color} fontWeight={500}>
              {translate({ intl, id: body })}
            </ParagraphRegular>
          )}
        </Styled.Description>
      </Styled.Wrapper>
    </Container>
  );
};

export default injectIntl(MapNextToText);
